import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { EPageTypes, EPlatformTypes, SimpleCall } from '@cian/frontend-newbuilding-call-component';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';

import { OpenedPhone } from './parts/OpenedPhone';
import { trackBuilderCallReasonsShowing } from './tracking';
import { trackShowPhone } from '../../actions/analytics';
import { BuilderCallReasons } from '../../components/BuilderCallReasons';
import { LayoutBlock } from '../../components/LayoutBlock';
import { getGaLabel } from '../../selectors/analytics';
import { getBuilders, getNewbuildingId, getSellers } from '../../selectors/newbuilding';
import { useApplicationContext } from '../../utils/applicationContext';
import { setUserOpenedPhoneInNewobject } from '../../utils/businessLogic/lastHopePopup';

export const BuilderCallReasonsContainer: React.FC = () => {
  const { httpApi, logger } = useApplicationContext();

  const builders = useSelector(getBuilders);
  const sellers = useSelector(getSellers);
  const newbuildingId = useSelector(getNewbuildingId);
  const gaLabel = useSelector(getGaLabel);

  const handleShowing = React.useCallback(() => {
    trackBuilderCallReasonsShowing();
  }, []);

  const handleShowPhone = React.useCallback(() => {
    setUserOpenedPhoneInNewobject(newbuildingId);
    trackShowPhone(gaLabel, 'Open_ask_builder');
  }, [gaLabel, newbuildingId]);

  return (
    <LayoutBlock data-testid="BuilderCallReasonsBlock">
      <ActionAfterViewObserver callback={handleShowing} triggerOnce callbackDelay={1000}>
        <BuilderCallReasons
          contactsButton={
            <SimpleCall
              builders={builders}
              sellers={sellers}
              openContactsStyles={{
                size: 'M' as const,
              }}
              showPhoneBuilderStyles={{
                size: 'M' as const,
                beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" />,
              }}
              showPhoneSellerStyles={{
                size: 'M' as const,
              }}
              httpApi={httpApi}
              logger={logger}
              onShowPhoneClick={handleShowPhone}
              pageType={EPageTypes.NewbuildingCard}
              platformType={EPlatformTypes.WebDesktop}
              placeType="blockBuilderCallReasons"
              withoutModal
              SinglePhoneComponent={OpenedPhone}
            />
          }
        />
      </ActionAfterViewObserver>
    </LayoutBlock>
  );
};
